import type {
  QuantityButtonsState,
  QuantityButtonsVariant,
} from "@intelligems/ig-types";

export function getQuantityButtonsVariantForOptions(
  state: QuantityButtonsState,
  options: Record<string, string> | undefined
) {
  if (options === undefined) {
    return undefined;
  }
  return state.variants?.find((variant) => isVariantEqual(variant, options));
}

function isVariantEqual(
  variant: QuantityButtonsVariant,
  options: Record<string, string>
) {
  for (const [name, value] of Object.entries(variant.options)) {
    if (options[name] !== value) {
      return false;
    }
  }
  return true;
}
